import { c as _c } from "react/compiler-runtime";
import type { AuditEventDetail } from '@onefootprint/request-types/dashboard';
import capitalize from 'lodash/capitalize';
import { useTranslation } from 'react-i18next';
import UpdatedRole from '../updated-role';
type UpdateOrgRoleProps = {
  detail: AuditEventDetail;
  hasPrincipalActor: boolean;
};
const UpdateOrgRole = t0 => {
  const $ = _c(16);
  const {
    detail,
    hasPrincipalActor
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.roles"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  if (detail.kind !== "update_org_role") {
    return null;
  }
  let t2;
  if ($[1] !== hasPrincipalActor || $[2] !== t) {
    t2 = hasPrincipalActor ? t(_temp) : capitalize(t(_temp2));
    $[1] = hasPrincipalActor;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <span className="text-body-2 text-tertiary">{t2}</span>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== detail) {
    t4 = <UpdatedRole detail={detail} />;
    $[6] = detail;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp3);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <span className="text-body-2 text-tertiary">{t5}</span>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t6) {
    t7 = <>{t3}{t4}{t6}</>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default UpdateOrgRole;
function _temp($) {
  return $.editedThe;
}
function _temp2($_0) {
  return $_0.editedThe;
}
function _temp3($_1) {
  return $_1.rolePermissions;
}